
import { defineComponent } from "vue";
import CardList from "@/components/Card/CardList.vue";
import ScrollArea from "@/components/ScrollAreas.vue";
import Pagination from "@/components/Pagination.vue";
import { programAreaPropAlt } from "@/props-config/application";
import { cardStyle, Datas } from "./Data";

export default defineComponent({
  name: "Tracking",
  components: {
    CardList,
    ScrollArea,
    Pagination,
  },
  data() {
    return {
      cardStyle,
      Datas,
      programAreaPropAlt,
      publishedData: [],
      publishedDataPagination: { size: 0, total_records: 0 } as {
        [key: string]: string | number;
      },
    };
  },
  methods: {
    async programArea(value: { [key: string]: string }) {
      console.log(value);
    },
  },
});
